import { TerraLink } from "../TerraLink/TerraLink"

export const LayoutCommonButtons = ({ buttons }: any) => {
  return buttons?.map((btn: TerraLink, index: number) => {
    return (
      <TerraLink
        key={`${btn.label}-${index}`}
        label={btn?.label}
        {...btn}
        destination={btn?.destination}
        primary={btn?.primary}
      />
    )
  })
}
